import React from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/design-system/atoms/button';
import { isBrowser } from '@/utils/util_helpers/ssr';

interface TakeMeEverywhereButtonProps {
  className?: string;
  iconSize?: number;
}

const TakeMeEverywhereButton: React.FC<TakeMeEverywhereButtonProps> = ({
  className,
  iconSize = 24,
}) => {
  const handleClick = () => {
    if (!isBrowser()) return;
    const lang = document.querySelector('html')?.lang || 'en';
    window.location.href = `/${lang}/shared-houses`;
  };

  const { t } = useTranslation();

  return (
    <Button
      type="button"
      onClick={handleClick}
      iconName="arrow-right-general"
      iconPosition="after"
      size="medium"
      className={clsx(
        'w-full rounded',
        'text-[16px] font-semibold text-N900',
        'bg-E30',
        'transition-colors duration-300 ease-in-out',
        'hover:bg-secondary-primaryHeavy',
        className
      )}
      nestedContainerClassName="!gap-2"
    >
      {t('js.components.take_me_everywhere_button.text')}
    </Button>
  );
};

export { TakeMeEverywhereButton };
